import { useCallback } from "react";

import { useAppNavigate } from "contexts";
import queryString from "query-string";
import { useLocation, useParams } from "react-router-dom";
import { parseLocation } from "utils";

const usePushRoute = () => {
  const { push } = useAppNavigate();
  const location = useLocation();
  const searchLocation = parseLocation();
  const paramUrl = useParams();

  const pushRoute = useCallback(
    (
      payload: Record<string, unknown>,
      to = location.pathname,
      config: { isReset?: boolean } = {}
    ) => {
      const { isReset = false } = config;
      const params = {
        ...(!isReset && searchLocation),
        ...payload,
      };
      push({
        to,
        params: queryString.stringify(params),
      });
    },
    [location.pathname, push, searchLocation]
  );

  return {
    pushRoute,
    searchLocation,
    paramUrl,
    location,
  };
};

export default usePushRoute;
